import { useSelector } from 'react-redux';

import { getIsDataFetching } from '../../selectors';
import { TableRow } from './TableRow';
import { TableHeader } from './TableHeader';
import { Skeleton } from './Skeleton';
import { DataFeed } from '../../types';

type Props = {
  rowData: DataFeed[];
};

export const testIds = {
  table: 'df-table',
};

export const Table = ({ rowData }: Props) => {
  const isLoading = useSelector(getIsDataFetching);

  const skeletons = Array(20)
    .fill({})
    .map((skeleton, i) => <Skeleton key={`skeleton-${i}`} />);

  return (
    <div data-test={testIds.table}>
      <TableHeader />
      {isLoading
        ? skeletons
        : rowData.map((row: DataFeed) => {
            return <TableRow key={`df-${row.id}`} rowData={row} />;
          })}
    </div>
  );
};
